import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { privateApi } from "../../../../api/api";
import { MergeReservationPayloadType } from "../../schema/MergeReservationSchema";
import { extractErrorMessage } from "../../../../shared/utils/serverValidation";

const API_VERSION = "v4";

const useMergeReservation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: MergeReservationPayloadType) => {
            const response = await privateApi.post(`/${API_VERSION}/booking/merge-reservation`, payload);
            return response.data;
        },
        onSuccess: async () => {
            // Invalidate calendar & detail data supaya segmen yang sudah digabung hilang dari UI
            await queryClient.invalidateQueries({ queryKey: ['bookings'] });
            await queryClient.invalidateQueries({ queryKey: ['booking'] });
            toast.success("Reservation merged successfully");
        },
        onError: (error: any) => {
            toast.error(extractErrorMessage(error, "Failed to merge reservation"));
        }
    });
};

export default useMergeReservation;
